export default {
  data() {
    return {
      allUsers: [
        /* -------------------------------------------------------------------------------
 AURELIUS KEVIN
--------------------------------------------------------------------------------------------------*/
        {
          path: 'aurel',
          name: 'Aurelius Kevin',
          email: 'aureliuskevint@gmail.com',
          behance: 'be.net/aureliuskevint',
          linkedin: 'linkedin.com/in/aureliuskevint',
          bio:
            'An explorative and curious person that likes adventures and learn new&nbsp;things.',
          works: {
            one: {
              id: 1,
              layout: 'carouselA',
              name: 'Frank Salon',
              type: 'Corporate Identity',
              desc:
                'Frank Salon is a Malaysian high-end indie salon founded in 2014. The art direction is inspired by organic styling, depicting the natural product and atmosphere that they offer. The colors and typography approach are minimalist and simple, applying earth tones and use only one elegant&nbsp;font.',
              sections: {
                one: {
                  name: 'Stationery Design',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
                two: {
                  name: 'Brand Communication',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
            two: {
              id: 2,
              layout: 'layoutB',
              name: 'Indonesian Heritage',
              type: 'Packaging',
              desc:
                'This packaging is a promotional item for the collaboration between Festival Mesin Waktu (90s Music Festival) and Sagoo’s Kitchen (Old Chinese Malay Restaurant). The mood and feel are nostalgic and traditional inspired by packaging in the 80s. It comes in a set of 5 and each packaging represents 1 big province in Indonesia, depicted by the pattern and product&nbsp;itself.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg'],
                },
              },
            },
            three: {
              id: 3,
              layout: 'layoutA',
              name: 'Malaysia’s Unwanted',
              type: 'Publication',
              desc:
                'Malaysia’s Unwanted is a publication project about different groups of people being shunned because they are considered criminals by Malaysian law and society. The purpose of the book is to deliver serious issues in a lighthearted way. I want to build curiosity and amusement with this “fun” approach by using a lot of illustrations and pictures in a playful&nbsp;mood.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
          },
        },
        /* -------------------------------------------------------------------------------
CHATERINE
--------------------------------------------------------------------------------------------------*/
        {
          path: 'chaterine',
          name: 'Chaterine Andreas',
          email: 'chaterineandreas@gmail.com',
          behance: 'be.net/chaterine98',
          linkedin: 'linkedin.com/in/chaterine98',
          bio:
            'She is a graphic designer that is ignited by passion, a person that will stop at nothing and always has the desire to go the extra mile. Passion is the match that lights her spirit through the difficult&nbsp;times.',
          works: {
            one: {
              id: 1,
              layout: 'carouselA',
              name: 'Jack the Clipper',
              type: 'Corporate Identity',
              desc:
                'Jack The Clipper is a barbershop with premium services that is worth the money. The name is taken from Jack The Ripper, the mysterious and elusive serial killer that terrorized London in 1888. Nowadays, Jack decided to start a new chapter in his life and pursued a career as a barber in Kuala Lumpur. Based on the mythologies about Grim Reaper taking people’s lives, his image was used as Jack’s personification since there were many suspects to who Jack the Ripper is, yet his identity remains unknown to this&nbsp;day.',
              sections: {
                one: {
                  name: 'Stationery Design',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
                two: {
                  name: 'Brand Communication',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
            two: {
              id: 2,
              layout: 'layoutB',
              name: 'Supermarket Sections',
              type: 'Pictogram Design',
              desc:
                'The pictogram is designed to be multifunctional. First, the main functions are to lead the customers towards things they are searching. It is used to give direction and sign because not all of the supermarket visitors understand and speak the same language. Second, it can be used as a design for shopping bag and other&nbsp;items.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg'],
                },
              },
            },
            three: {
              id: 3,
              layout: 'layoutA',
              name: 'When Chinese Meets Melayu',
              type: 'Publication',
              desc:
                'When Chinese Meets Melayu is a book that studies anthropology of the Chinese in Malaysia, which puts together the history and the current life situation of the Malaysian Chinese. The book is not a culture book, therefore, it is not designed with typical Chinese graphics and elements. The graphics are styled minimalist to balance out the colors (red and black) and the heavy topics so readers are not&nbsp;overwhelmed.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
          },
        },
        /* -------------------------------------------------------------------------------
GOH SZE CHIEN
--------------------------------------------------------------------------------------------------*/
        {
          path: 'szechien',
          name: 'Goh Sze Chien',
          email: 'szechien960@gmail.com',
          behance: 'be.net/szechien096',
          linkedin: 'linkedin.com/in/sze-chien-goh-/',
          bio:
            'She is the rainbow after the rain. She will always keep a positive mindset even during the toughest of times. Challenges are her friends as she takes them as opportunities to grow and to&nbsp;learn.',
          works: {
            one: {
              id: 1,
              layout: 'carouselB',
              name: 'Upstairs Cafe',
              type: 'Corporate Identity',
              desc:
                'Upstairs cafe is a hidden cafe in SS12 Subang Jaya on the upper level of the shop lot building. Their logo is constructed from the shape of a hammock to indicate the cozy and calming atmosphere of the cafe. The cafe itself is like a hanging hammock, where people come to enjoy the laid-back, relaxing&nbsp;moments.',
              sections: {
                one: {
                  name: 'Stationery Design',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg'],
                },
                two: {
                  name: 'Brand Communication',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
            two: {
              id: 2,
              layout: 'layoutA',
              name: 'My Childhood Primary School',
              type: 'Publication',
              desc:
                'This book is a tribute to our childhood primary school, where there was no cell phone, no internet, only valuable&nbsp;lessons.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
            three: {
              id: 3,
              layout: 'layoutA',
              name: 'What If Tiger Were Replaced?',
              type: 'Advertising Campaign',
              desc:
                'In response to the Malayan Tiger’s extinction, WWF teamed up with famous brands in Malaysia that have a tiger in their logo to pull a public stunt. Big brands such as Maybank, Kuat Harimau, Tiger Sugar, Tiger Biscuit and Tiger Balm simultaneously replaced their tiger logo to that of a cat. The purpose of this campaign is to shock people and educate the public about the disappearance of Malayan&nbsp;tigers.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
          },
        },
        /* -------------------------------------------------------------------------------
ANH
--------------------------------------------------------------------------------------------------*/
        {
          path: 'anh',
          name: 'Ho Nguyen Phuong Anh',
          email: 'anhhophuong@gmail.com',
          behance: 'be.net/anhhophuong',
          linkedin: 'linkedin.com/in/anhhophuong',
          bio:
            'She is the creator of her own path and the designer of her own life. She let nothing hold her back as she fearlessly forges the way to her&nbsp;dream.',
          works: {
            one: {
              id: 1,
              layout: 'carouselA',
              name: 'Frank Salon',
              type: 'Corporate Identity',
              desc:
                'Inspired by the salon’s serene atmosphere and the beauty of perfect hair, Frank’s identity was formed. The icon of a relaxed face with flowy hair can be also depicted as the initial letter of the name Frank. They believe that in order to bring out true beauty, one must first slip into the state of utter relaxation and&nbsp;zen.',
              sections: {
                one: {
                  name: 'Stationery Design',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg'],
                },
                two: {
                  name: 'Brand Communication',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
            two: {
              id: 2,
              layout: 'layoutB',
              name: 'RuNam Coffee',
              type: 'Packaging',
              desc:
                'The Dragon God and Mother Fairy was the origin of Vietnamese people. The carves on the surface of the bronze drum tell the story of how life was like in the old days. This RuNam limited coffee packaging is designed in the spirit of the Vietnamese glorious past to remind people that our coffee culture is part of our way of&nbsp;life.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg'],
                },
              },
            },
            three: {
              id: 3,
              layout: 'layoutA',
              name: 'Those Who Wander',
              type: 'Publication',
              desc:
                'Hidden within the busy streets of Kuala Lumpur lies countless paw prints of our feline friends. Those who wander in the cold, dark nights. This is a book that aims to lift the curtain on the hidden community of strays so people can finally understand and hopefully develop more compassion toward&nbsp;them.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
          },
        },
        /* -------------------------------------------------------------------------------
 HUI SAN
--------------------------------------------------------------------------------------------------*/
        {
          path: 'huisan',
          name: 'How Hui San',
          email: 'howhuisan@gmail.com',
          behance: 'be.net/huisan0220',
          linkedin: 'linkedin.com/in/huisan0220',
          bio:
            'She is a force to be reckoned with. She is the one that screams “Nothing is impossible” as she forges her way through all the hardship to reach her wanted&nbsp;destination.',
          works: {
            one: {
              id: 1,
              layout: 'carouselB',
              name: 'Twolip Dreadshoppe',
              type: 'Corporate Identity',
              desc:
                'Twolip Dreadshoppe is a mysterious and cool dreadlock stylist and their mission is to promote the beauty of dreadlock to the fashion industry and society. The shop logo is formed by a butterfly with its wings looking like the face of a skull. Therefore, at first people would see a scary face but once they see a bigger picture, they’ll see a beautiful butterfly just like how dreadlocks can be intimate at first but as the younger generations are getting more woke, they can start to appreciate it as an art form true to its&nbsp;nature.',
              sections: {
                one: {
                  name: 'Stationery Design',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
                two: {
                  name: 'Brand Communication',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
            two: {
              id: 2,
              layout: 'layoutA',
              name: 'Tai Thong',
              type: 'Packaging',
              desc:
                'Tai Thong launched a special mooncake set with the theme of “月在屋圆” to remind people of the heartwarming feeling during family reunions and the traditional customs of Mid-Autumn&nbsp;Festival.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
            three: {
              id: 3,
              layout: 'layoutA',
              name: 'The Crossover of Malaysian Cuisine',
              type: 'Publication',
              desc:
                'This publication project aims to introduce people to Malaysian food and culture. Malaysian cuisine consists of cooking traditions and practices that reflect the multi-ethnic makeup of its population. Hence, I came up with four books entitled ‘Nasi’, ‘Drinks’, ‘Snacks’, and ‘Kuih Muih’ in order to introduce these traditions and&nbsp;practices.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
          },
        },
        /* -------------------------------------------------------------------------------
JAMES
--------------------------------------------------------------------------------------------------*/
        {
          path: 'james',
          name: 'James Henry Purnama',
          email: 'jamespurnama1@gmail.com',
          behance: 'be.net/jamespurnama',
          linkedin: 'linkedin.com/in/jamespurnama',
          bio:
            'He is a creative with a wide range of out-of-the-box solutions. Also, a tool and software tinkerer and an explorative spirit, especially, in the ideation process. All these he has achieved from his past explorations and discoveries. Yet, he is still eager to learn more through his curiosity-driven&nbsp;process.',
          works: {
            one: {
              id: 1,
              layout: 'layoutB',
              name: 'Sagoo',
              type: 'Packaging',
              desc:
                'Sagoo is a vintage themed restaurant in Bandung, Indonesia. Aside from selling food, they sell nostalgic items on the side as a waroeng. This project aims to bring back Indonesian nostalgic toys and candies with a packaging experience. The set includes a paper bag, bola bekel, gasing bamboe, and permen&nbsp;rokok.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg'],
                },
              },
            },
            two: {
              id: 2,
              layout: 'layoutA',
              name: 'Epic',
              type: 'Branding',
              desc:
                'Epic or Epic Homes is a non-profit organization purposed to build houses for the homeless. Epic stands for Extraordinary People Impacting Communities. They believe in relationships, which is the differentiator of a house, and a home. This branding project serves to impact a growing community that genuinely&nbsp;cares.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
            three: {
              id: 3,
              layout: 'carouselA',
              name: 'Jack The Clipper',
              type: 'Corporate Identity',
              desc:
                'Jack the Clipper is a unique barbershop experience taken from a well-known serial killer, Jack the Ripper. The idea behind the logo is a combination of bold old-school typeface with an unidentifiable common head and a clipper. The person in the logo brings a mysterious mood while the font shows seriousness in a ‘40s typeface. The clipper makes the brand identifiable as a barber as well as a representation of a&nbsp;weapon.',
              sections: {
                one: {
                  name: 'Stationery Design',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg'],
                },
                two: {
                  name: 'Brand Communication',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
          },
        },
        /* -------------------------------------------------------------------------------
LAU WAI YEE
--------------------------------------------------------------------------------------------------*/
        {
          path: 'waiyee',
          name: 'Lau Wai Yee',
          email: 'lauwaiyee82@gmail.com',
          behance: 'be.net/lauwaiyee82',
          linkedin: 'linkedin.com/in/lauwaiyee',
          bio:
            'When it comes to design, there is only one word to describe her attitude: passionate. Her passion allows her to face every difficulty head on, again and again until she finds the answers to her&nbsp;problems.',
          works: {
            one: {
              id: 1,
              layout: 'carouselB',
              name: 'Twolip Dreadshoppe',
              type: 'Corporate Identity',
              desc:
                'Twolip Dreadshoppe an exclusive salon that offers special hairstyling services such as braids, cornrows and dreadlocks. To form the logo, I’ve rolled the braids and snake together to represent the natural formation of dreadlocks. The reason behind the imagery of a snake is that the snake brings out feelings of creative self expression unified with a naturalistic sense of&nbsp;style.',
              sections: {
                one: {
                  name: 'Stationery Design',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
                two: {
                  name: 'Brand Communication',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
            two: {
              id: 2,
              layout: 'layoutB',
              name: 'Zensuous',
              type: 'Packaging',
              desc:
                'Zensuous is a proud homegrown brand providing and supplying quality aromatherapy and spa related products. They decided to launch a special gift set featuring natural massage oil and scented candles. Every ingredient used in the products are illustrated in the&nbsp;packaging.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg'],
                },
              },
            },
            three: {
              id: 3,
              layout: 'layoutA',
              name: 'The Last Day On Earth',
              type: 'Publication',
              desc:
                'This publication project is all about Malaysian traditional funerals: from the essential preparation, the procedure to every taboo to be avoided during these ceremonies. Since there are three main races in Malaysia, which are Malay, Chinese and Indian, the project contains three books, each dedicated to one&nbsp;race.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
          },
        },
        /* -------------------------------------------------------------------------------
 LIEW KAR MUN
--------------------------------------------------------------------------------------------------*/
        {
          path: 'karmun',
          name: 'Liew Kar Mun',
          email: 'Kar14Mun@gmail.com',
          behance: 'be.net/veronicaliew',
          linkedin: 'linkedin.com/in/karmun1018',
          bio:
            'She’s a passionate girl who never gives up upon facing difficulties. In fact, she’s always looking forward to the next problem because she views them as the chances to grow in both spirit and&nbsp;skills.',
          works: {
            one: {
              id: 1,
              layout: 'carouselA',
              name: 'Hair Menu Wigs',
              type: 'Corporate Identity',
              desc:
                'Hair Menu here to help customers to customize a Wig that look like Your Old Self again! “ A Wig is like another Ray of Hope ” The logo is formed by an Art Nouveau mirror with olive leaves and a beautiful girl. The olive tree represents peace and hope while the mirror brings out the feeling of&nbsp;confidence.',
              sections: {
                one: {
                  name: 'Stationery Design',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
                two: {
                  name: 'Brand Communication',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
            two: {
              id: 2,
              layout: 'layoutB',
              name: 'Ban Heang',
              type: 'Packaging',
              desc:
                'Ban Heang’s principle is our freshness guarantee’s promise to their customers – “Made Now, Bake Now, and Sell Now”.there are more than 200 types of product available in Ban Heang. To highlight the many benefits of Malaysian coconuts, Ban Heong launches a limited gift set featuring coconut candy and biscuit. The doodling of the ingredients together with the brown paper set a traditional and natural overall mood to the whole&nbsp;set.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg'],
                },
              },
            },
            three: {
              id: 3,
              layout: 'layoutA',
              name: 'Darkside Behind the School',
              type: 'Publication',
              desc:
                'Darkside Behind the School is a publication project that discusses the seriousness of school bullying in Malaysia and its effects. Only three colors can be seen in this book: Red for anger, Blue for sadness and Yellow for&nbsp;helplessness.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
          },
        },
        /* -------------------------------------------------------------------------------
SAMANTHA
--------------------------------------------------------------------------------------------------*/
        {
          path: 'sam',
          name: 'Samantha Lung',
          email: 'samanthalung3122@gmail.com',
          behance: 'be.net/samlung',
          linkedin: 'linkedin.com/in/sammlkm',
          bio:
            'A passionate, loud and friendly designer! Constantly helping out others is a norm for her but she works well both in a team and as an individual! As a photographer, she’s deeply invested about creating the visions that came from her mind, giving life to the works she&nbsp;creates.',
          works: {
            one: {
              id: 1,
              layout: 'carouselA',
              name: 'John Lau Guitar Repair Store',
              type: 'Corporate Identity',
              desc:
                'John Lau Guitar Repair Store was founded in 2004. The owner, John has a very close bond with his customers because he helps reform their once broken guitars. The concept was inspired by the red string of fate, representing the strong connection between the client and the owner just like that of the guitar&nbsp;strings.',
              sections: {
                one: {
                  name: 'Stationery Design',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg'],
                },
                two: {
                  name: 'Brand Communication',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
            two: {
              id: 2,
              layout: 'layoutA',
              name: 'Nita Cosmetics',
              type: 'Packaging',
              desc:
                'Nita’s Cosmetics was founded by Aznita, a proud Malaysian who brought a new and more modern style to Malaysian culture. The purpose of this packaging is to rebrand Nita’s Cosmetics to a more vibrant and aesthetic version of Baba Nyonya’s culture because they’re the most famous and one of the most beautiful cultures from&nbsp;Malaysia.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
            three: {
              id: 3,
              layout: 'layoutB',
              name: 'I’m Fine / Save Me',
              type: 'Publication',
              desc:
                'I’m Fine/ Save Me is an awareness publication project that educates the public about the causes and dangerous effects of severe mental illnesses. The book delivers serious issues in a deep, informative way. It starts out vibrant and bright but as readers progress, the pages get darker and more muted. The goal is to show that on the outside, a person may seem cheerful and normal but as you dive in deeper, you will learn about the highly critical stage of their mental&nbsp;health.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg'],
                },
              },
            },
          },
        },
        /* -------------------------------------------------------------------------------
SEOW WEI HANG
--------------------------------------------------------------------------------------------------*/
        {
          path: 'weihang',
          name: 'Seow Wei Hang',
          email: 'seowweihang@gmail.com',
          behance: 'be.net/weihangseow',
          linkedin: 'linkedin.com/in/seowweihang',
          bio:
            'A person who’s KEE “SEOW” and the KEE “SEOW”ness makes him better person. It teaches him perfectionism, patience and to not give up. He will utilize his KEE “SEOW”ness to its fullest&nbsp;potential.',
          works: {
            one: {
              id: 1,
              layout: 'carouselB',
              name: 'Twolip Dreadshoppe',
              type: 'Corporate Identity',
              desc:
                'Twolip Dreadshoppe an exclusive salon that offers special hairstyling services such as braids, cornrows and dreadlocks. The logo is inspired by the beauty of dreadlocks, complex like the root and will turn absolutely gorgeous like the flower upon&nbsp;finishing.',
              sections: {
                one: {
                  name: 'Stationery Design',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg'],
                },
                two: {
                  name: 'Brand Communication',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
            two: {
              id: 2,
              layout: 'layoutB',
              name: 'Harriston Chocolate',
              type: 'Packaging',
              desc:
                'Since Malaysia is the homeland of the Orangutans, Harriston Chocolate decided to launch a limited edition gift set to educate tourists about said animal and promote Malaysian beautiful culture to the&nbsp;world.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg'],
                },
              },
            },
            three: {
              id: 3,
              layout: 'layoutA',
              name: '21 Years Old Night-Life',
              type: 'Publication',
              desc:
                'A book that educates young adults who just turn 21 about what can and cannot be done regarding nightlife activities. Six different duotones are used to differentiate these wild and exciting&nbsp;topics.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
          },
        },
        /* -------------------------------------------------------------------------------
 TAN ZHI JIAN
--------------------------------------------------------------------------------------------------*/
        {
          path: 'zhijian',
          name: 'Tan Zhi Jian',
          email: 'leotanw0729@gmail.com',
          behance: 'behance.net/zhijian1',
          linkedin: 'linkedin.com/in/tanzhijian',
          bio:
            'He is an imaginative and adventurous person that likes to find fresh things to learn in both life and design. For him new things are a long-term investment as they give new skills for the future as well as new angles of thinking and&nbsp;creating.',
          works: {
            one: {
              id: 1,
              layout: 'carouselB',
              name: 'The Daily Grind',
              type: 'Corporate Identity',
              desc:
                'The Daily Grind is a gourmet burger restaurant that needed to change a look and feel to match their unique environment in Bangsar’s franchise. Rather using underground and subway as their main&nbsp;theme.',
              sections: {
                one: {
                  name: 'Stationery Design',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg'],
                },
                two: {
                  name: 'Brand Communication',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
            two: {
              id: 2,
              layout: 'layoutB',
              name: 'Self Identity',
              type: 'Personal Branding',
              desc:
                'The set of stationary is to describe what I am as a designer. The imaginative and adventurous side of me. The imaginative side of me always brought me to the weirdest place for this idea. For example what will a designer look like if they are just a blob? the basic shape or&nbsp;form.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg'],
                },
              },
            },
            three: {
              id: 3,
              layout: 'layoutB',
              name: 'A Shame Culture',
              type: 'Publication',
              desc:
                'Underage sexual harassment is happen pretty often in Malaysian despite often bring it out by locals,by local shyness and sensitive nature. By using bright colours and light, the topic will be more easier to talk with friend and family to create awareness for underage sexual&nbsp;harassment.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg'],
                },
              },
            },
          },
        },
        /* -------------------------------------------------------------------------------
VIANKA
--------------------------------------------------------------------------------------------------*/
        {
          path: 'vianka',
          name: 'Vianka',
          email: 'viankagunawan@gmail.com',
          behance: 'be.net/viankawu',
          linkedin: 'linkedin.com/in/viankawu',
          bio:
            'A designer who’s always hungry for more, who is never content because there is always more to learn and more to achieve.',
          works: {
            one: {
              id: 1,
              layout: 'carouselA',
              name: 'Jack the Clipper',
              type: 'Corporate Identity',
              desc:
                'Jack the Clipper was in need of a refresh to stand out in a busy and crowded Kuala Lumpur that is already full of barbershops. As the name of the brand is inspired by the infamous serial killer called Jack the Ripper, this barbershop wants to embrace that spirit through their design and&nbsp;environment.',
              sections: {
                one: {
                  name: 'Stationery Design',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
                two: {
                  name: 'Brand Communication',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
            two: {
              id: 2,
              layout: 'layoutB',
              name: 'Rempah Nusantara',
              type: 'Packaging',
              desc:
                'Rempah Nusantara wants to promote Indonesia’s native spices by providing convenience in cooking Indonesian dishes without the need to add other seasonings. The packaging is a limited set that includes two traditional dish’s spices and a jar of authentic chili paste. The box shape itself is inspired by the traditional house of Java called Joglo as the dish comes from Java island. The tone and manner of the design is natural, authentic, and&nbsp;traditional.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: ['img0.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg'],
                },
              },
            },
            three: {
              id: 3,
              layout: 'layoutA',
              name: 'You probably (don’t) need this guidebook',
              type: 'Publication',
              desc:
                'Guidebooks are boring. Tourists tend to google to find what they are looking for instead of flipping through a travel guide. Therefore, in this guidebook, the readers will only find answers to questions they have never thought of. While having fun reading and interacting with the book, readers will also get to know the unique side of Malaysian through this&nbsp;guidebook.',
              sections: {
                one: {
                  name: '',
                  img: [],
                },
                two: {
                  name: '',
                  img: [
                    'img0.jpg',
                    'img1.jpg',
                    'img2.jpg',
                    'img3.jpg',
                    'img4.jpg',
                  ],
                },
              },
            },
          },
        },
      ],
    };
  },
};
